import { render, staticRenderFns } from "./ShowRoot.vue?vue&type=template&id=65a6dc1c&"
import script from "./ShowRoot.vue?vue&type=script&lang=js&"
export * from "./ShowRoot.vue?vue&type=script&lang=js&"
import style0 from "./ShowRoot.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports